// extracted by mini-css-extract-plugin
export default {"PageNotFound":"PageNotFound_PageNotFound__ziE+f","Button":"PageNotFound_Button__6Q+aj"};